let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3fUyq")).then(() => parcelRequire('2NNqU'));